import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SubSection, SubSectionTitle } from './styles';

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
`;

const Link = styled.a`
  margin-right: 16px;
  outline: none !important;

  &:hover {
    text-decoration: none !important;
  }

  span.icon-lw {
    font-size: 28px;

    &:hover:before {
      color: #788B9B;
    }
  }

  svg {
    display: block;
    color: #a4b6c6;

    &:hover {
      color: #788B9B;
    }
  }
`;

const XIcon = styled.svg.attrs({
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
})`
  width: 28px;
  height: 28px;
`;

export default function Social({ linkedinUrl, twitterUrl, activeFeatures }) {
  const isPremiumSocialLinksEnabled = _.includes(activeFeatures, 'premium_social_links');

  if (!(isPremiumSocialLinksEnabled && (linkedinUrl || twitterUrl))) {
    return null;
  }

  return (
    <SubSection>
      <SubSectionTitle>Social</SubSectionTitle>
      <LinkContainer>
        {linkedinUrl && (
          <Link href={linkedinUrl} target="_blank">
            <span className="icon-lw icon-lw-linkedin-alt" />
          </Link>
        )}
        {twitterUrl && (
          <Link href={twitterUrl} target="_blank">
            <XIcon>
              <path d="M36.6526 3.80762H43.3995L28.6594 20.6546L46 43.5796H32.4225L21.7881 29.6757L9.61989 43.5796H2.86886L18.6349 25.5598L2 3.80762H15.9222L25.5348 16.5163L36.6526 3.80762ZM34.2846 39.5412H38.0232L13.8908 7.63388H9.87892L34.2846 39.5412Z" fill="currentColor" />
            </XIcon>
          </Link>
        )}
      </LinkContainer>
    </SubSection>
  );
}

Social.propTypes = {
  linkedinUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  activeFeatures: PropTypes.arrayOf(PropTypes.string),
};

Social.defaultProps = {
  linkedinUrl: null,
  twitterUrl: null,
  activeFeatures: [],
};
